export default __webpack_public_path__ + "static/media/0x87ff96aba480f1813af5c780387d8de7cf7d8261.32f9cf6d.webp";